const POLICIES_DEVIATIONS = 'policies/deviations/';
const POLICY_TYPE_ID = 'uuid-for-icah-policy-type';
const REPORT_SIZE = '/reportsize/';
const REPORT = '/report/';
const MICROSOFT_LOGIN = '/login/microsoft';

export { POLICIES_DEVIATIONS, POLICY_TYPE_ID, REPORT_SIZE, REPORT, MICROSOFT_LOGIN };
